"use client";

import { Icon } from "@iconify/react";

/** Une classe de taille : w-, h- ou size-, variantes comprises (sm:w-5). */
const TAILLE = /(^|\s)(?:[\w-]+:)*!?(?:w|h|size)-/;
/** Une classe d'affichage, que la réserve ne doit pas écraser. */
const AFFICHAGE = /(^|\s)(?:[\w-]+:)*!?(?:block|inline|inline-block|inline-flex|flex|grid|hidden|contents)(?=\s|$)/;

/**
 * Icône Solar servie par Iconify. `name` est le slug Solar sans son préfixe :
 * "alt-arrow-down-linear" devient "solar:alt-arrow-down-linear".
 *
 * LA PLACE EST RÉSERVÉE AVANT LE CHARGEMENT. Iconify rend un `<span>` vide
 * tant que l'icône n'est pas arrivée : le texte voisin se décalait d'une
 * icône au moment où elle apparaissait. La réserve reprend les classes de
 * l'icône ; sans classe de taille, elle prend 1em de côté, comme le SVG.
 *
 * @param {object} props
 * @param {string} props.name        Slug Solar, suffixe de variante compris.
 * @param {string} [props.className] Classes utilitaires : taille, couleur, opacité.
 * @param {object} [props.style]     Styles en ligne, pour ce que Tailwind ne couvre pas.
 */
export default function SolarIcon({ name, className, style }) {
    const classes = className || "";
    const reserve = [
        classes,
        AFFICHAGE.test(classes) ? "" : "inline-block",
        TAILLE.test(classes) ? "" : "w-[1em] h-[1em]",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Icon
            icon={`solar:${name}`}
            className={className}
            style={style}
            aria-hidden="true"
            fallback={<span className={reserve} style={style} aria-hidden="true" />}
        />
    );
}
